import { useReducedMotion } from "motion/react";

import { useScreen0Language } from "@/features/language";
import { getTranslations } from "@/i18n";
import { resolveQuickStartFabIcon } from "./quickStartIcons";

type QuickStartFabProps = {
  fabIcon: string | undefined;
  onOpen: () => void;
};

export function QuickStartFab({ fabIcon, onOpen }: QuickStartFabProps) {
  const { languageCode } = useScreen0Language();
  const t = getTranslations(languageCode);
  const prefersReducedMotion = useReducedMotion();
  const Icon = resolveQuickStartFabIcon(fabIcon);

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-[calc(max(12px,env(safe-area-inset-bottom))+72px)] z-[35] flex justify-center px-4">
      <button
        type="button"
        onClick={onOpen}
        aria-label={t.rules.quickStart.fabAria}
        className={`liquid-glass-fab pointer-events-auto inline-flex min-h-11 items-center gap-2 rounded-full px-4 py-2.5 text-sm font-semibold text-[oklch(12%_0.015_160)] transition-transform active:scale-[0.97]${prefersReducedMotion ? "" : " motion-safe:hover:scale-[1.02]"}`}
      >
        <Icon size={18} aria-hidden />
        {t.rules.quickStart.fabLabel}
      </button>
    </div>
  );
}
